/**
 * @generated SignedSource<<71d87a2f69d66a063c92ea35b331ca48>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowSellerSince_seller$data = {
  readonly dealerSince: string | null;
  readonly monthsSinceStartDate: number | null;
  readonly " $fragmentType": "useShowSellerSince_seller";
};
export type useShowSellerSince_seller$key = {
  readonly " $data"?: useShowSellerSince_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowSellerSince_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowSellerSince_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dealerSince",
      "storageKey": null
    },
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "51518c9324c49e5114d9d7afd0234c5f";

export default node;
